import React, { useEffect, useState } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 720) setOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <>
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <div className="container-x nav-row">
          <a href="#top" className="brand" onClick={close}>
            <span className="mark">R</span>
            <span className="who">Raphaël Bertaina-Loichemol</span>
          </a>
          <div className="nav-links">
            <a href="#about">About</a>
            <a href="#work">Work</a>
            <a href="#skills">Skills</a>
            <a href="#contact">Contact</a>
          </div>
          <a href="#contact" className="btn ghost nav-cta" style={{ padding: '8px 14px', fontSize: 13 }}>
            <span className="label">Get in touch</span>
            <svg className="arrow" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4"><path d="M3 11L11 3M5 3h6v6" /></svg>
          </a>
          <button className="hamburger" onClick={() => setOpen(o => !o)} aria-label="Toggle menu">
            <span className={open ? 'open' : ''} />
            <span className={open ? 'open' : ''} />
            <span className={open ? 'open' : ''} />
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${open ? 'is-open' : ''}`} aria-hidden={!open}>
        <a href="#about" onClick={close}>About</a>
        <a href="#work" onClick={close}>Work</a>
        <a href="#skills" onClick={close}>Skills</a>
        <a href="#contact" onClick={close}>Contact</a>
        <a href="#contact" onClick={close} className="mobile-cta btn primary">
          <span className="label">Get in touch</span>
        </a>
      </div>
    </>
  );
}
